import React from "react";
import { useState, useEffect, useRef } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import ScorecardFilters from "../App/ScorecardFilters";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import TabFilter from "../App/TabFilter";
import MultiTabFilter from "../App/MultiTabFilter";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import LineChartSmall from "../Charts/LineChartSmall";
import LineChart from "../Charts/LineChart";
import DownloadPopup from "../App/DownloadPopup";
import { SortTheList } from "../Shared/Utility";

function YTDLeagueTableTrends() {
  let toggledatarangeArray = [
    { Name: "Absolute", ID: 1 },
    { Name: "Comparative", ID: 2 },
  ];
  let toggledataArray = [
    { Name: "Retailer", ID: 1 },
    { Name: "Importer", ID: 2 },
  ];
  let multiMSAArray = [
    { Name: "Network", ID: 1 },
    { Name: "Sales", ID: 2 },
    { Name: "Aftersales", ID: 3 },
  ];

  const [screenID, setScreenID] = useState(10);
  const [
    YTDTableFactorKeysDataForScoringTrend,
    setYTDTableFactorKeysDataForScoringTrend,
  ] = useState<any>([]);
  const [showLoadinganimation, setShowLoadinganimation] = useState(false);

  const [lineChartPopup, setLineChartPopup] = useState(false);
  const [selectedId, setSelectedId] = useState({
    Dealers: 0,
    Facilities: 0,
    Years: 0,
    Months: 0,
    Brand: 0,
  });

  const [tabFilterObject, setTabFilterObject] = useState({
    toggledata: 1,
    Toggledatarange: 1,
  });

  const [multiTabFilterObject, setMultiTabFilterObject] = useState<any>({
    Network: 1,
    Sales: 1,
    Aftersales: 1,
    DefaultValue: "Network",
  });

  ///--States for columnFilter components---///
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [filterLists, setFilterLists] = useState([]);
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = YTDTableFactorKeysDataForScoringTrend as any;
    l_data[1] = FilterData;
    setYTDTableFactorKeysDataForScoringTrend(l_data);
    thisGridListDataRef.current = FilterData;
    HandleSortAndLoadData();
  }

  //--States for columnFilter components---///

  function handleTabFilterCallback(TabFilterData: any) {
    let ID = TabFilterData.ID;
    let Type = TabFilterData.Type;
    if (Type === 1) {
      tabFilterObject.Toggledatarange = ID;
      setTabFilterObject((prevState: any) => ({
        ...prevState,
        Toggledatarange: ID,
      }));
    } else if (Type === 2) {
      tabFilterObject.toggledata = ID;
      setTabFilterObject((prevState: any) => ({
        ...prevState,
        toggledata: ID,
      }));
    }
  }

  function handleMultiTabFilterCallback(MultiTabFilterData: any) {
    let ID = MultiTabFilterData.ID;
    let Value = MultiTabFilterData.Value;
    let Name = MultiTabFilterData.Name;
    let Type = MultiTabFilterData.Type;
    if (Type === 1) {
      setMultiTabFilterObject((prevState: any) => ({
        ...prevState,
        [Name]: Value,
      }));
    }
  }


  useEffect(() => {
    let count = 0;
    for (let key in multiTabFilterObject) {
      if (multiTabFilterObject[key] === 0) {
        count++;
      }
    }
    if (count === multiMSAArray.length) {
      setMultiTabFilterObject((prevState: any) => ({
        ...prevState,
        [multiTabFilterObject.DefaultValue]: 1,
      }));
    }
  }, [multiTabFilterObject]);


  function ScorecardFiltersCallBack(p_selectedId: any) {
    selectedId.Dealers = parseInt(p_selectedId.Dealers);
    if (selectedId.Dealers === 0) {
      selectedId.Facilities = 0;
    } else {
      selectedId.Facilities = parseInt(p_selectedId.Facilities);
    }

    selectedId.Years = p_selectedId.Years;
    selectedId.Months = p_selectedId.Months;
    selectedId.Brand = p_selectedId.Brand;

    setSelectedId(selectedId);
    getYTDTableFactorKeysDataForScoringTrend();
  }

  useEffect(() => {
    getYTDTableFactorKeysDataForScoringTrend();
  }, [
    multiTabFilterObject,
    tabFilterObject,
    selectedId.Brand,
    selectedId.Years,
  ]);

  function getYTDTableFactorKeysDataForScoringTrend() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = screenID;
    object.network = multiTabFilterObject.Network;
    object.sales = multiTabFilterObject.Sales;
    object.aftersales = multiTabFilterObject.Aftersales;
    object.brandid = selectedId.Brand;
    object.year = selectedId.Years;
    object.toggledata = tabFilterObject.toggledata;
    object.typeofreportdata = 1;
    object.toggledatarange = tabFilterObject.Toggledatarange;
    object.approved = 1;
    setShowLoadinganimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFIRSFactorKey/GetYTDTableFactorKeysDataForScoringTrend",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;

          let rank = 0;
          for (var k = 0; k < l_response[1].length; k++) {
            if (l_response[1][k].DealerName === "MENA Average") {
              l_response[1][k].Rank = 0;
            } else {
              rank += 1;
              l_response[1][k].Rank = rank;
            }
          }

          setYTDTableFactorKeysDataForScoringTrend(l_response);

          setThisGridListData(l_response[1]);
          thisGridListDataRef.current = l_response[1];
          HandleSortAndLoadData();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  const [trendingGraphFactorObject, setTrendingGraphFactorObject] = useState({
    dealerid: 0,
    ficilityid: 0,
    name: "",
    year: 0,
    brand: 0,
    keyid: 0,
    factortype: 0,
    typeid: 0,
    quaternuber: 0,
    screenid: 0,
  });

  function bindTrendingGraphFactor(
    dealerid: any,
    ficilityid: any,
    name: any,
    year: any,
    brand: any,
    keyid: any,
    factortype: any,
    typeid: any,
    quaternuber: any,
    screenid: any
  ) {
    if (name.indexOf("MENA Average") < 0) {
      getTrendingGraphData(
        dealerid,
        ficilityid,
        name,
        year,
        brand,
        keyid,
        factortype,
        typeid,
        quaternuber,
        screenid
      );
    }
  }

  function getTrendingGraphData(
    dealerid: any,
    ficilityid: any,
    name: any,
    year: any,
    brand: any,
    keyid: any,
    factortype: any,
    typeid: any,
    quaternuber: any,
    screenid: any
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = screenid;
    object.network = 1;
    object.sales = 1;
    object.aftersales = 1;
    object.qid = quaternuber;
    object.facilityid = ficilityid;
    object.dealerid = dealerid;
    object.brandid = brand;
    object.year = year;
    object.factorid = -1;
    trendingGraphFactorObject.name = name;

    setShowLoadinganimation(true);

    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFIRSFactorKey/GetTrendingGraphData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          //setTrendingGraphFactorData(l_response);

          MakeLineGraphData(l_response);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }

        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  const [lineDataNumbers, setlineDataNumbers] = useState<[number, number][][]>(
    []
  );
  const [monthLabels, setmonthLabels] = useState<string[]>([]);
  interface MonthData {
    Score: number;
    NumericYear: number;
    NumericMonth: number;
    MonthName: string;
  }

  const [graphLine, setGraphLine] = useState<[number, number][]>([]);

  function MakeLineGraphData(p_trendingGraphFactorData: any) {
    console.log(p_trendingGraphFactorData);

    var j = lineDataNumbers.length;
    for (var k = 0; k < j; k++) lineDataNumbers.pop();
    var j2 = monthLabels.length;
    for (var k = 0; k < j2; k++) monthLabels.pop();
    p_trendingGraphFactorData.map((lineData: []) => {
      setGraphLine([]);

      lineData.map((monthData: MonthData) => {
        var monthName = monthData.MonthName;
        var monthIndex = 0;
        var monthFound = false;

        monthLabels.map((name, index) => {
          if (name == monthName) {
            monthFound = true;
            monthIndex = index + 1;
          }
        });
        if (monthFound == false) {
          monthLabels.push(monthName);
          monthIndex = monthLabels.length;
        }

        graphLine.push([monthIndex, monthData.Score]);
      });
      var l = graphLine.length;
      if (l > 0) {
        var newGraphLine = JSON.parse(JSON.stringify(graphLine));
        for (var k = 0; k < l; k++) graphLine.pop();
        lineDataNumbers.push(newGraphLine);
      }
    });
    if (lineDataNumbers.length > 0) setLineChartPopup(true);
  }

  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpFileURL, setPopUpFileURL] = useState("");
  const [popUpMessage, setPopUpMessage] = useState("Data has been exported to file successfully.!");
  function DownloadPopupCallBack() {
    setShowPopUp(false);
    setPopUpFileURL("");
  }

  function getSectionScorecardFactorKeysDataForExport() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = screenID;
    object.facilityid = selectedId.Facilities;
    object.dealerid = selectedId.Dealers;
    object.brandid = selectedId.Brand;
    object.year = selectedId.Years;
    object.month = selectedId.Months;
    object.toggledata = tabFilterObject.toggledata;
    object.step = 1;
    object.typeofreportdata = 1;
    object.toggledatarange = tabFilterObject.Toggledatarange;
    setShowLoadinganimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFIRSFactorKey/GetSectionScorecardFactorKeysDataForExport",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].DownloadData;
          if (l_response[0][0].Status === 1) {
            setPopUpFileURL(link);
            setShowPopUp(true);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  ////  Sorting Starts    /////

  const [filters, setFilters] = useState(["ScoreYTD", "D"]);
  const [thisGridListData, setThisGridListData] = useState([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;

  function SetSortingImage() {
    let imgSortApr: any = document.getElementById("imgSortScoreQ1");
    imgSortApr.innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortScoreQ2") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortScoreQ3") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortScoreQ4") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (document.getElementById("imgSortScoreYTD") as HTMLInputElement).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortScoreAvgQ1") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortScoreAvgQ2") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortScoreAvgQ3") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortScoreAvgQ4") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="13px" height="15px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="13px" height="15px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="page--contents">
      {showLoadinganimation && <LoadingAnimation />}
      <DownloadPopup
        ShowPopup={showPopUp}
        FileLink={popUpFileURL}
        Message={popUpMessage}
        DownloadPopupCallBack={DownloadPopupCallBack}
      />
      <div className="page--breadcrumb">
        <a>YTD League Table & Scoring Trends</a>
      </div>
      <div className="page--data">
        <div className="flex-container">
          <div className="flex-items">
            <ScorecardFilters
              ScreenID={screenID}
              ScorecardFiltersCallBack={ScorecardFiltersCallBack}
            />

            <TabFilter
              DataType={1}
              SelectedValue={tabFilterObject.Toggledatarange}
              DataList={toggledatarangeArray}
              TabFilterCallback={handleTabFilterCallback}
            />

            <TabFilter
              DataType={2}
              SelectedValue={tabFilterObject.toggledata}
              DataList={toggledataArray}
              TabFilterCallback={handleTabFilterCallback}
            />

            <MultiTabFilter
              DataType={1}
              SelectedValue={multiTabFilterObject}
              DataList={multiMSAArray}
              MultiTabFilterCallback={handleMultiTabFilterCallback}
            />
          </div>
        </div>
        {YTDTableFactorKeysDataForScoringTrend &&
          YTDTableFactorKeysDataForScoringTrend.length > 0 && (
            <>
              <div className="section-table">
                {YTDTableFactorKeysDataForScoringTrend[0] && (
                  <div className="legends-buttons">
                    <div className="single-legend">
                      <p>
                        {YTDTableFactorKeysDataForScoringTrend[0][0].ScoreTop}
                      </p>
                      <span className="legend-1"></span>
                    </div>
                    <div className="single-legend">
                      <p>
                        {
                          YTDTableFactorKeysDataForScoringTrend[0][0]
                            .ScoreMiddle
                        }{" "}
                      </p>
                      <span className="legend-2"></span>
                    </div>
                    <div className="single-legend">
                      <p>
                        {
                          YTDTableFactorKeysDataForScoringTrend[0][0]
                            .ScoreBottom
                        }
                      </p>
                      <span className="legend-3"></span>
                    </div>
                    <div className="single-legend">
                      <p>INACTIVE</p>
                      <span className="legend-4"></span>
                    </div>
                    <a
                      className="btn-primary"
                      title="Export"
                      onClick={() =>
                        getSectionScorecardFactorKeysDataForExport()
                      }
                    >
                      <img
                        src="images/export.png"
                        width="13px"
                        height="15px"
                        alt="export"
                      />
                    </a>
                  </div>
                )}

                <div className="flex-details table-norms">
                  {YTDTableFactorKeysDataForScoringTrend[1] && (
                    <ColumnFilterCheckboxList
                      DataType={1}
                      RefreshFilters={refreshFilters}
                      GridData={YTDTableFactorKeysDataForScoringTrend[1]}
                      ColumnName={selectedColumnName}
                      ColumnFilterCheckboxListCallback={
                        filterCheckboxListCallback
                      }
                      GetFilteredLists={getFilteredLists}
                      ReturnAllFilterdLists={{}}
                      ClickPosition={clickPosition}
                      Orientation={"Center"}
                      ColumnOrientation={[
                        { Name: "DealerName", Orientation: "Right" },
                      ]}
                    />
                  )}
                  <div className="table-scroll">
                    <table className="part-head trend-table" id="tblData">
                      <thead>
                        <tr>
                          <th>Rank</th>

                          <th>
                            <span
                              onClick={(e) =>
                                ShowColumnFilterList(e, "DealerName")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              Importer Name
                            </span>
                          </th>
                          <th>
                            <span
                              onClick={(e) => ShowColumnFilterList(e, "Market")}
                              data-function="ShowColumnFilterList"
                            >
                              Market
                            </span>
                          </th>
                          <th>
                            <span
                              onClick={(e) =>
                                ShowColumnFilterList(e, "Facility")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              Retailer
                            </span>
                          </th>
                          <th>
                            <span
                              onClick={(e) =>
                                ShowColumnFilterList(e, "FacilityType")
                              }
                              data-function="ShowColumnFilterList"
                            >
                              RT
                            </span>
                          </th>
                          <th>
                            <span className="sort-spn">Q1</span>
                            <a
                              onClick={() => LoadWithSelectedSort("ScoreQ1")}
                              title="Sort By Q1"
                            >
                              <span id="imgSortScoreQ1"></span>
                            </a>
                          </th>
                          <th>
                            <span className="sort-spn">Q2</span>
                            <a
                              onClick={() => LoadWithSelectedSort("ScoreQ2")}
                              title="Sort By Q2"
                            >
                              <span id="imgSortScoreQ2"></span>
                            </a>
                          </th>
                          <th>
                            <span className="sort-spn">Q3</span>
                            <a
                              onClick={() => LoadWithSelectedSort("ScoreQ3")}
                              title="Sort By Q3"
                            >
                              <span id="imgSortScoreQ3"></span>
                            </a>
                          </th>
                          <th>
                            <span className="sort-spn">Q4</span>
                            <a
                              onClick={() => LoadWithSelectedSort("ScoreQ4")}
                              title="Sort By Q4"
                            >
                              <span id="imgSortScoreQ4"></span>
                            </a>
                          </th>
                          <th>
                            <span className="sort-spn">Cumulative YTD</span>
                            <a
                              onClick={() => LoadWithSelectedSort("ScoreYTD")}
                              title="Sort By Cumulative YTD"
                            >
                              <span id="imgSortScoreYTD"></span>
                            </a>
                          </th>
                          <th>
                            <span className="sort-spn">Q1 Monthly Ave.</span>
                            <a
                              onClick={() => LoadWithSelectedSort("ScoreAvgQ1")}
                              title="Sort By Q1 Monthly Ave"
                            >
                              <span id="imgSortScoreAvgQ1"></span>
                            </a>
                          </th>
                          <th>
                            <span className="sort-spn">Q2 Monthly Ave.</span>
                            <a
                              onClick={() => LoadWithSelectedSort("ScoreAvgQ2")}
                              title="Sort By Q2 Monthly Ave"
                            >
                              <span id="imgSortScoreAvgQ2"></span>
                            </a>
                          </th>
                          <th>
                            <span className="sort-spn">Q3 Monthly Ave.</span>
                            <a
                              onClick={() => LoadWithSelectedSort("ScoreAvgQ3")}
                              title="Sort By Q3 Monthly Ave"
                            >
                              <span id="imgSortScoreAvgQ3"></span>
                            </a>
                          </th>
                          <th>
                            <span className="sort-spn">Q4 Monthly Ave.</span>
                            <a
                              onClick={() => LoadWithSelectedSort("ScoreAvgQ4")}
                              title="Sort By Q4 Monthly Ave"
                            >
                              <span id="imgSortScoreAvgQ4"></span>
                            </a>
                          </th>
                          <th>Trend</th>
                        </tr>
                      </thead>
                      <tbody>
                        {thisGridListData &&
                          thisGridListData.map((item: any, index: any) => (
                            <React.Fragment key={"Main" + index}>
                              {!item.IsExcluded &&
                                (selectedId.Dealers == 0 ||
                                  selectedId.Dealers == item.DealerID) &&
                                (selectedId.Facilities == 0 ||
                                  selectedId.Facilities == item.FacilityID) && (
                                  <tr>
                                    <td
                                      className={
                                        "ScoreCategory" + item.ScoreType
                                      }
                                    >
                                      {item.Rank}
                                    </td>
                                    <td
                                      className={
                                        "ScoreCategory" + item.ScoreType
                                      }
                                    >
                                      {item.DealerName}
                                    </td>
                                    <td
                                      className={
                                        "ScoreCategory" + item.ScoreType
                                      }
                                    >
                                      {item.Market}
                                    </td>
                                    <td
                                      className={
                                        "ScoreCategory" + item.ScoreType
                                      }
                                    >
                                      {item.Facility}
                                    </td>
                                    <td
                                      className={
                                        "ScoreCategory" + item.ScoreType
                                      }
                                    >
                                      {item.FacilityType}
                                    </td>

                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreTypeScoreQ1
                                      }
                                      onClick={() =>
                                        bindTrendingGraphFactor(
                                          item.DealerID,
                                          item.FacilityID,
                                          item.DealerName +
                                            " [" +
                                            item.Facility +
                                            "]",
                                          selectedId.Years,
                                          selectedId.Brand,
                                          0,
                                          0,
                                          1,
                                          1,
                                          screenID
                                        )
                                      }
                                    >
                                      {item.ScoreQ1}
                                    </td>
                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreTypeScoreQ2
                                      }
                                      onClick={() =>
                                        bindTrendingGraphFactor(
                                          item.DealerID,
                                          item.FacilityID,
                                          item.DealerName +
                                            " [" +
                                            item.Facility +
                                            "]",
                                          selectedId.Years,
                                          selectedId.Brand,
                                          -1,
                                          -1,
                                          -1,
                                          2,
                                          screenID
                                        )
                                      }
                                    >
                                      {item.ScoreQ2}
                                    </td>
                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreTypeScoreQ3
                                      }
                                      onClick={() =>
                                        bindTrendingGraphFactor(
                                          item.DealerID,
                                          item.FacilityID,
                                          item.DealerName +
                                            " [" +
                                            item.Facility +
                                            "] ",
                                          selectedId.Years,
                                          selectedId.Brand,
                                          0,
                                          0,
                                          1,
                                          3,
                                          screenID
                                        )
                                      }
                                    >
                                      {item.ScoreQ3}
                                    </td>
                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreTypeScoreQ4
                                      }
                                      onClick={() =>
                                        bindTrendingGraphFactor(
                                          item.DealerID,
                                          item.FacilityID,
                                          item.DealerName +
                                            " [" +
                                            item.Facility +
                                            "] " ,
                                          selectedId.Years,
                                          selectedId.Brand,
                                          0,
                                          0,
                                          1,
                                          4,
                                          screenID
                                        )
                                      }
                                    >
                                      {item.ScoreQ4}
                                    </td>
                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreType
                                      }
                                      onClick={() =>
                                        bindTrendingGraphFactor(
                                          item.DealerID,
                                          item.FacilityID,
                                          item.DealerName +
                                            " [" +
                                            item.Facility +
                                            "] " ,
                                          selectedId.Years,
                                          selectedId.Brand,
                                          0,
                                          0,
                                          1,
                                          5,
                                          screenID
                                        )
                                      }
                                    >
                                      <b>{item.ScoreYTD}</b>
                                    </td>
                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreType
                                      }
                                    >
                                      {item.ScoreAvgQ1}
                                    </td>
                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreType
                                      }
                                    >
                                      {item.ScoreAvgQ2}
                                    </td>
                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreType
                                      }
                                    >
                                      {item.ScoreAvgQ3}
                                    </td>
                                    <td
                                      className={
                                        "text-right ScoreCategory" +
                                        item.ScoreType
                                      }
                                    >
                                      {item.ScoreAvgQ4}
                                    </td>

                                    <td>
                                      <LineChartSmall
                                        tdID={"tdTrend" + index}
                                        data={[
                                          [1, item.ScoreQ1],
                                          [2, item.ScoreQ2],
                                          [3, item.ScoreQ3],
                                          [4, item.ScoreQ4],
                                        ]}
                                      />
                                    </td>
                                  </tr>
                                )}
                            </React.Fragment>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
      </div>
      {lineChartPopup && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Trending: {trendingGraphFactorObject.name}</h3>
                <a
                  className="close-help"
                  onClick={() => setLineChartPopup(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="popup-message">
                <LineChart data={lineDataNumbers} labelsProps={monthLabels} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default YTDLeagueTableTrends;
